$(document).ready(function(){
  $('.header__links-list li.main_links').mouseenter(function(){
    // console.log('4444');    
    $('.main_links .navigation__submenu-item').each(function(){
      $(this).children('ul.navigation__submenu').removeClass('active');
    });

    var self = $(this);
    $('.header__links-list li.main_links').each(function(){        
      $(this).removeClass('active');    
    });    
    $(this).addClass('active');
    //     $(this).find('ul').addClass('active');
  });
})
$(document).on('mouseenter','.main_links.active',function(){
  // console.log('3333');    
  var self = $(this);
  $('.main_links').each(function(){
    $(this).children('ul.navigation__submenu').removeClass('active');
  });
  self.children('ul.navigation__submenu').addClass('active');
});
$(document).on('mouseenter','.main_links.active .navigation__submenu-item',function(){
  // console.log('2222');    
  var self = $(this);
  var getdatadepth = $(this).parent('.navigation__submenu').attr('data-depth');
  console.log(getdatadepth);

  $('.main_links.active .navigation__submenu-item').each(function(){
    var datadepth = $(this).parent('.navigation__submenu').attr('data-depth');    
    if(datadepth >= getdatadepth){
      $(this).children('ul.navigation__submenu').removeClass('active');
    }

  });
  self.children('ul.navigation__submenu').addClass('active');
});
$(document).on('mouseleave','.main_links',function(){
  // console.log('1111');
  //     $(this).find('ul').removeClass('active');    
  $('.main_links.active .navigation__submenu-item').each(function(){
    //         $(this).parent('.navigation__submenu').removeClass('active');
    $(this).find('ul').removeClass('active');
  });
});
$(document).on('mouseover', function(e) {
  var container = $("header.header");
  // if the target of the click isn't the container nor a descendant of the container
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    $('.header__links-list li.main_links').removeClass('active');
    $('.header__links-list li.main_links').children('ul.navigation__submenu').removeClass('active');
  }
});


